module.exports = __webpack_public_path__ + "ddc17d6d059a586f9807c05eb102c6d1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/winking-11.png
// module id = 2276
// module chunks = 0